"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _objectHash = _interopRequireDefault(require("object-hash"));

var _Alert = _interopRequireDefault(require("./Alert"));

var _StaggeredFadeIn = _interopRequireDefault(require("./effect/animation/StaggeredFadeIn"));

var _styling = require("../toolkit/styling");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AlertList = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(AlertList, _Component);

  var _super = _createSuper(AlertList);

  function AlertList() {
    (0, _classCallCheck2["default"])(this, AlertList);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(AlertList, [{
    key: "render",
    value: function render() {
      var _this = this;

      var className = this.props.className;
      var alerts = this.alerts;

      if (alerts.length === 0) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_StaggeredFadeIn["default"], {
        deltaY: -10,
        animationDurationMs: 350,
        className: (0, _styling.css)(this.styles.root, className)
      }, alerts.map(function (alert, idx) {
        return /*#__PURE__*/_react["default"].createElement(_Alert["default"], (0, _extends2["default"])({}, alert, {
          key: (0, _objectHash["default"])(alert),
          className: (0, _styling.css)(_this.styles.item)
        }));
      }));
    }
  }, {
    key: "styles",
    get: function get() {
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch"
        },
        item: {
          borderBottom: "solid 1px #e8e8e8",
          marginBottom: 7
        }
      });
    }
  }, {
    key: "alerts",
    get: function get() {
      var alerts = this.props.alerts; // Typecase as null values have been filtered out of the array

      return alerts.filter(function (_) {
        return _ != null;
      });
    }
  }]);
  return AlertList;
}(_react.Component), _class3.propDoc = {
  alerts: {
    required: true,
    type: "ReadonlyArray<AlertType>",
    description: "List of props for the [`Alert`](/lego/component/Alert)s" + " we need to render"
  }
}, _class3.demoProps = {
  alerts: [{
    text: "This is an negative alert",
    sentiment: "negative",
    link: {
      text: "optional link",
      url: "http://www.google.com"
    }
  }, {
    text: "Congratulations! This is an positive alert!",
    sentiment: "positive"
  }]
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "alerts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "alerts"), _class2.prototype)), _class2)) || _class;

var _default = AlertList;
exports["default"] = _default;